export default __webpack_public_path__ + "static/media/user-icon.6367abad.svg";